<div
  class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-text-center"
  [class.tw-min-h-[60vh]]="!compact"
  [class.tw-py-8]="compact"
>
  <img loading="lazy" src="/images/dog.png" alt="" class="tw-w-[96px] tw-h-[68px]" />

  <div class="tw-flex tw-flex-col tw-gap-1.5">
    <span class="tw-text-base tw-font-semibold tw-text-dt-text-headings">{{
      titleKey | i18n
    }}</span>
    @if (descriptionKey) {
      <span class="tw-text-sm tw-text-dt-text-disabled">{{ descriptionKey | i18n }}</span>
    }
  </div>

  @if (actionLabelKey) {
    <app-gloss-button
      class="tw-w-44"
      [options]="{
        text: actionLabelKey | i18n,
        class: 'neutral',
        isEnabled: true,
        icon: actionIcon,
        onClick: onActionClick,
      }"
    ></app-gloss-button>
  }
</div>
